import CloseIcon from '@mui/icons-material/Close';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { IconButton } from 'shared/mui/IconButtons';
import { GatewayRule } from 'types/embedded/gatewayRule';

type Props = {
  onConfirm: () => void;
  onClose: () => void;
  record?: GatewayRule;
} & DialogProps;

export const GatewayRuleActiveSwitchConfirm: React.FC<Props> = ({
  onConfirm,
  open,
  onClose,
  record,
}) => {
  const translate = useTypedTranslate();

  if (!record) {
    return <></>;
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <Card>
        <CardHeader
          appendActions={[
            <IconButton aria-label="close" key="close-button" onClick={onClose}>
              <CloseIcon />
            </IconButton>,
          ]}
          title={
            record.active
              ? translate('app.gatewayRules.disableRule')
              : translate('app.gatewayRules.enableRule')
          }
          titleSize="smallBold"
        />
        <CardContent sx={{ width: '552px' }}>
          {record.active
            ? translate('app.gatewayRules.disableRuleMessage', { name: record?.name })
            : translate('app.gatewayRules.enableRuleMessage', { name: record?.name })}
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <Button
              key="cancel-button"
              label={translate('app.buttons.cancel')}
              onClick={onClose}
              variant="outlined"
            />,
            <Button
              key="confirm-button"
              label={translate('app.buttons.approve')}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
